import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalBodyWrapper: {
        padding: theme.spacing(4),
    },
    autocompleteWrapper: {
        "& .MuiInputBase-root:before": {
            borderBottom: "none !important",
        },
    },
    listItemWrapper: {
        padding: theme.spacing(3),
        display: "flex",
        gap: theme.spacing(4),
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.border.main,
        },
    },
    listItemTextWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    listItemText: {
        fontFamily: "Open Sans",
    },
    listItemTextSubtitle: {
        fontFamily: "Open Sans",
        fontSize: "12px",
    },
    listItemTextNoEmail: {
        fontFamily: "Open Sans",
    },
    listContainer: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
    },
    listItem: {
        display: "flex",
        marginBottom: "10px",
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: 600,
            color: theme.palette.secondary.dark,
        },
    },
    separatorNoPadding: {
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        width: "100%",
    },
    listItemContainer: {
        display: "flex",
        gap: theme.spacing(2),
    },
    listContainerTitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: theme.palette.secondary.dark,
    },
    divider: {
        marginTop: theme.spacing(2),
    },
}));
